import * as React from 'react'
import { SVGProps } from 'react'

export const PapperplaneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 16 16" {...props}>
    <path
      d="M15.597.188A1.012 1.012 0 0 0 15.034 0a.947.947 0 0 0-.501.156L.504 8.125c-.344.219-.532.563-.5.938 0 .343.25.687.594.843l3.226 1.344 1.941 4.594c.063.125.157.156.22.156.062 0 .124 0 .156-.063l2.693-2.562 3.757 1.563a.997.997 0 0 0 .407.062.935.935 0 0 0 .47-.125.877.877 0 0 0 .5-.719l2.005-12.969a.935.935 0 0 0-.376-1ZM1.005 9l11.9-6.781-9.05 8L1.005 9Zm5.261 5.469L4.732 10.78l7.17-6.344L6.61 11.72c-.094.125-.125.281-.094.437.063.156.157.281.314.313l1.064.437-1.628 1.563Zm6.764-.594L7.8 11.781l7.046-9.687-1.816 11.781Z"
      fill={'currentColor'}
    />
  </svg>
)
